/**
* DevExpress Dashboard (_chart-legend.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { parseBool } from '../../../metadata/_base-metadata';
export let outsidePosition = {
    propertyName: 'outsidePosition', modelName: '@OutsidePosition', displayName: 'DashboardWebStringId.Chart.Position', defaultVal: 'TopRightHorizontal', simpleFormAdapterItem: 'selectBoxEditor', values: {
        'TopLeftVertical': 'DashboardWebStringId.Chart.Position.TopLeftVertical',
        'TopLeftHorizontal': 'DashboardWebStringId.Chart.Position.TopLeftHorizontal',
        'TopCenterHorizontal': 'DashboardWebStringId.Chart.Position.TopCenterHorizontal',
        'TopRightVertical': 'DashboardWebStringId.Chart.Position.TopRightVertical',
        'TopRightHorizontal': 'DashboardWebStringId.Chart.Position.TopRightHorizontal',
        'BottomLeftVertical': 'DashboardWebStringId.Chart.Position.BottomLeftVertical',
        'BottomLeftHorizontal': 'DashboardWebStringId.Chart.Position.BottomLeftHorizontal',
        'BottomCenterHorizontal': 'DashboardWebStringId.Chart.Position.BottomCenterHorizontal',
        'BottomRightVertical': 'DashboardWebStringId.Chart.Position.BottomRightVertical',
        'BottomRightHorizontal': 'DashboardWebStringId.Chart.Position.BottomRightHorizontal'
    }
};
export let insidePosition = {
    propertyName: 'insidePosition', modelName: '@InsidePosition', displayName: 'DashboardWebStringId.Chart.Position', defaultVal: 'TopRightHorizontal', simpleFormAdapterItem: 'selectBoxEditor', values: {
        'TopLeftVertical': 'DashboardWebStringId.Chart.Position.TopLeftVertical',
        'TopLeftHorizontal': 'DashboardWebStringId.Chart.Position.TopLeftHorizontal',
        'TopCenterHorizontal': 'DashboardWebStringId.Chart.Position.TopCenterHorizontal',
        'TopCenterVertical': 'DashboardWebStringId.Chart.Position.TopCenterVertical',
        'TopRightVertical': 'DashboardWebStringId.Chart.Position.TopRightVertical',
        'TopRightHorizontal': 'DashboardWebStringId.Chart.Position.TopRightHorizontal',
        'BottomLeftVertical': 'DashboardWebStringId.Chart.Position.BottomLeftVertical',
        'BottomLeftHorizontal': 'DashboardWebStringId.Chart.Position.BottomLeftHorizontal',
        'BottomCenterHorizontal': 'DashboardWebStringId.Chart.Position.BottomCenterHorizontal',
        'BottomCenterVertical': 'DashboardWebStringId.Chart.Position.BottomCenterVertical',
        'BottomRightVertical': 'DashboardWebStringId.Chart.Position.BottomRightVertical',
        'BottomRightHorizontal': 'DashboardWebStringId.Chart.Position.BottomRightHorizontal'
    }
};
export let isInsideDiagram = { propertyName: 'isInsideDiagram', modelName: '@IsInsidePosition', displayName: 'DashboardWebStringId.Chart.IsInsideOfDiagram', defaultVal: false, simpleFormAdapterItem: 'yesNoButtonGroupEditor', from: parseBool };
export let chartLegendVisible = { propertyName: 'visible', modelName: '@Visible', displayName: 'DashboardWebStringId.Chart.ShowLegend', defaultVal: true, simpleFormAdapterItem: 'yesNoButtonGroupEditor', from: parseBool };
export let chartLegendSerializationsInfo = [outsidePosition, insidePosition, isInsideDiagram, chartLegendVisible];
